<template>
  <div class="html-content" v-html="htmlContent"></div>
</template>

<script>
import {loadJS} from '@/utils/util'
let loaded = false
let loading = false
let timer
export default {
  name: 'HTMLContent',
  props: {
    html: '',
    mathClass: {
      default: 'math-tex'
    },
    plainHTML: false
  },
  data () {
    return {
      htmlContent: ''
    }
  },
  watch: {
    html () {
      this.renderHTML()
    }
  },
  methods: {
    _renderHTML () {
      this.htmlContent = this.trimHTML()
      if (loading) return
      this.$nextTick(() => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          const el = document.getElementsByClassName(this.mathClass)
          if (el.length > 0) {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, el])
          }
        }, 0)
      })
    },
    renderHTML () {
      this.htmlContent = `<p><i class="el-icon-loading margin-right-10"></i>正在加载...</p>`
      this.loadLib().then(() => {
        this._renderHTML()
      })
    },
    loadLib () {
      if (loaded || loading || this.plainHTML) {
        return Promise.resolve()
      } else {
        loading = true
        return loadJS('https://cdn.bootcss.com/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML')
          .then(() => {
            loading = false
            loaded = true
          }, (err) => {
            console.log(`load mathjax plugin fail:${err}`)
          })
      }
    },
    trimHTML (plainHTML = true) {
      if (plainHTML || this.plainHTML) return this.html
      let $html = $(`<div>${this.html}</div>`)
      // p标签
      let $child = $html.children()
      let $el, text, children
      if ($child.length > 0) {
        for (let i = 0; i < $child.length; i++) {
          $el = $child.eq(i)
          text = $el.text().replace(/\s/g, '')
          if (!text) {
            children = $el.children()
            if (children.length <= 0) {
              $el.remove()
            } else if (children.length === 1 && children.eq(0).prop('outerHTML').trim().match(/<[/]*br[/]*>/)) {
              $el.remove()
            }
          }
        }
      }
      return $html.prop('outerHTML')
    }
  },
  mounted () {
    this.html && this.renderHTML()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/HTMLContent/index.vue